<template>
	<li tabindex="0" :id="'program-' + itemID">
		<span class="list-item-info">
			<span class="label">Participating Supplier</span>
			<span :aria-label="'Participating Supplier' + result.SupplierName" class="value">{{result.SupplierName}}</span>
		</span>
		<span class="list-item-info">
			<span class="label">Accrual</span>
			<span :aria-label="'Accrual' + calcPercent(result.AccrualPercent) + '%'" class="value">{{calcPercent(result.AccrualPercent)}}%</span>

		</span>
		<span class="list-item-info">
			<span class="label">Adv.</span>
			<span :aria-label="'Adv' + result.SharedAdvertising" class="value">{{result.SharedAdvertising}}</span>

		</span>
		<span v-if="!isReadOnly" class="list-item-info item-control">
			<span v-if="!iscurrentsub"
				  aria-label="Add Supplier"
				  class="icon icon-plus add-supplier js-program-toggle"
				  tabindex="0"
				  v-on:click="addConfirm(iscurrentsub)"
				  v-on:keydown.enter="addConfirm(iscurrentsub)"></span>
			<span v-if="iscurrentsub"
				  aria-label="Remove Supplier"
				  class="icon icon-block remove-supplier js-program-toggle"
				  tabindex="0"
				  v-on:click="removeConfirm(iscurrentsub)"
				  v-on:keydown.enter="removeConfirm(iscurrentsub)"></span>
		</span>
	</li>


</template>

<script>
	import { create } from 'vue-modal-dialogs';
	import SupplierAdd from './supplier-add';
	import SupplierRemove from './supplier-remove';
	import * as ModalResponse from '../../common/modal-response.js';

	const addDialog = create(SupplierAdd, 'result');
	const removeDialog = create(SupplierRemove, 'result');

	export default {
	props: {
			result: {
				type: Object,
				default: () => {}
		},
			iscurrentsub: {
				type: Boolean
			}
	},
	data: function () {
		return {
			itemID: null,
			isReadOnly: true,
			toggleData: {
                supplierNumber: this.result.SupplierNo,
				isAdd: false
			}
		}
	},
	watch: {

	},
	mounted() {
		this.itemID = this._uid;
		this.result.itemID = this.itemID;
		this.isReadOnly = window.isReadOnly;
	},
	methods: {
		addConfirm(result) {
			document.getElementsByTagName('body')[0].classList.add('dim');

			addDialog(this.result).then((val) => this.updateParticipating(val));
		},
		calcPercent(result) {
			return result * 100;
		},
		removeConfirm(result) {
			document.getElementsByTagName('body')[0].classList.add('dim');

			removeDialog(this.result).then((val) => this.updateParticipating(val));
		},
		updateParticipating(newVal) {

			if(newVal === ModalResponse.SUPPLIER_ADDED) {
				this.toggleData.isAdd = true;
				this.result.IsSubscribed = true;
				this.addApiUrls();
			}
			else if (newVal === ModalResponse.SUPPLIER_REMOVED) {
				this.toggleData.isAdd = false;
				this.result.IsSubscribed = false;
				this.addApiUrls();
			}
		},
        addApiUrls() {
			this.$emit('togglecapsupplier', this.toggleData);
		},
	}
	}

</script>